import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/productos/searchProductos.php';

export default function searchProductos({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}